import { AppAreaConfig } from '@/funnels/@types'
import maleActivityMilitaryCalisthenics from './activity-male-military-calisthenics'
import femaleActivityMilitaryCalisthenics from './activity-female-military-calisthenics'

const appAreaConfig: AppAreaConfig = {
	appArea: 'main-military-calisthenics',
	options: {
		userTags: ['calisthenics'],
	},
	landing: {
		ids: ['loader-military-calisthenics', 'age-military-calisthenics'],
		route: {
			path: '/military-calisthenics',
			name: 'main-military-calisthenics-funnel',
		},
	},
	funnel: {
		id: 'ob-military-calisthenics-gender-selection',
		route: {
			path: '/military-calisthenics/ob/:page(.*)?',
			name: 'main-military-calisthenics',
		},
		slug: 'main-military-calisthenics',
		locale: ['en'],
		redirectTo: {
			sex: {
				male: { appArea: maleActivityMilitaryCalisthenics },
				female: { appArea: femaleActivityMilitaryCalisthenics },
			},
		},
	},
}

export default appAreaConfig
